import React from "react";
import RecruitModalBase from "./RecruitModalContent/RecruitModalBase";
import useRecruitsAddFetch from "../../fetches/RecruitsAddFetch";

/**
 * AddRecruitModal - Component for adding a new recruit
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {string} [props.modal_header="Добавить кандидата"] - Modal header text
 */
const AddRecruitModal = ({
  isOpen,
  onClose,
  modal_header = "Добавить новую запись",
}) => {
  const { addRecruit } = useRecruitsAddFetch();

  return (
    <RecruitModalBase
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={modal_header}
      onSubmit={addRecruit}
      submitButtonText="Сохранить"
      isEditMode={false}
    />
  );
};

export default AddRecruitModal;
